import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-30dcb3d0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "wrap-container spacelist"
};
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
import beaconSDK from '@/utils/report';
import BeaconSpacePage from './main.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var store = useStore();
    var showNewSpaceModal = ref(false);
    var searchInput = ref('');
    var corporationId = ref('');
    var appKey = ref('');
    var createButtonShow = ref(false);
    var spaceConfig = window.AppConfig.space; // computed

    var isAdmin = computed(function () {
      return store.state.company.isAdmin;
    }); // 拉取全部/我的空间列表

    var fetchSpaceList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var data, spaceList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.getMySpaceList(_objectSpread({
                  appKey: appKey.value,
                  corporationId: corporationId.value
                }, params));

              case 2:
                data = _context.sent;

                if (!(data.data.code === 1)) {
                  _context.next = 6;
                  break;
                }

                spaceList = data.data.result.itemList.map(function (item) {
                  return {
                    bizId: item.id,
                    isOwner: item.is_owner,
                    bizName: item.name,
                    // admins: item.adminList.map((admin: any) => admin.name).join(';'),
                    admins: item.adminList.map(function (admin) {
                      return {
                        name: admin.name,
                        loginName: admin.login_name
                      };
                    }),
                    bizUrl: item.bizUrl,
                    adminCount: item.adminList.length
                  };
                });
                return _context.abrupt("return", {
                  bizList: spaceList,
                  totalCount: data.data.result.totalCount
                });

              case 6:
                ElMessage({
                  message: data.data.msg,
                  type: 'error'
                });
                return _context.abrupt("return", {
                  bizList: [],
                  totalCount: 0
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchSpaceList(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var handleNewSpace = function handleNewSpace() {
      beaconSDK.sdkReport('space_create_click');
      showNewSpaceModal.value = true;
    };

    var goSpacePage = function goSpacePage(url) {
      location.href = url;
    };

    var openNewBizModal = function openNewBizModal(newBiz) {
      if (isAdmin.value && newBiz === '1') {
        handleNewSpace();
      }
    }; // 获取当前产品的有效期状态


    var getAppStatus = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data;

        var data, activeData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CompanyService.getAppActiveDetail({
                  corporationId: corporationId.value
                });

              case 2:
                data = _context2.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  activeData = data.data.result.find(function (item) {
                    return item.appKey === appKey.value;
                  });

                  if ((activeData === null || activeData === void 0 ? void 0 : activeData.expiredState) === 2 && (activeData === null || activeData === void 0 ? void 0 : activeData.remainingTime) < 30) {
                    ElMessage({
                      message: "\u60A8\u7684\u4F01\u4E1A\u8D2D\u4E70\u7684 ".concat(activeData.currentVersion, " \u4EA7\u54C1\u5269\u4F59\u6709\u6548\u671F\u4EC5\u6709 ").concat(activeData.remainingTime, " \u5929"),
                      type: 'error'
                    });
                  }
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getAppStatus() {
        return _ref2.apply(this, arguments);
      };
    }(); // 拉取空间角色组的方法


    var roleGroupList = function roleGroupList() {
      return new Promise(function (resolve) {
        resolve([{
          roleName: '全站关注人'
        }, {
          roleName: '产品人员'
        }, {
          roleName: '开发人员'
        }, {
          roleName: '运营人员'
        }, {
          roleName: '数据分析人员'
        }, {
          roleName: '测试人员'
        }, {
          roleName: '高层决策者'
        }, {
          roleName: '空间管理员'
        }]);
      });
    };

    var createSpace = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bizId, bizName, checkedList) {
        var _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return CompanyService.createSpace({
                  appKeys: checkedList.join(';'),
                  appKey: appKey.value,
                  corporationId: corporationId.value,
                  bizId: bizId,
                  bizName: bizName
                });

              case 2:
                data = _context3.sent;

                if (!(((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1)) {
                  _context3.next = 6;
                  break;
                }

                ElMessage({
                  message: '创建成功!',
                  type: 'success'
                });
                return _context3.abrupt("return", data.data);

              case 6:
                ElMessage({
                  message: data.data.msg,
                  type: 'error'
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function createSpace(_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    var clickSpace = function clickSpace(_ref4) {
      var bizId = _ref4.bizId,
          bizName = _ref4.bizName,
          bizUrl = _ref4.bizUrl;

      if (bizUrl) {
        window.open(bizUrl);
      } else {
        window.open("".concat(location.origin, "/").concat(bizId));
      }
    };

    var _route$query = route.query,
        _route$query$corp_id = _route$query.corp_id,
        corp_id = _route$query$corp_id === void 0 ? '' : _route$query$corp_id,
        _route$query$app_key = _route$query.app_key,
        app_key = _route$query$app_key === void 0 ? '' : _route$query$app_key,
        new_biz = _route$query.new_biz;
    appKey.value = (app_key === null || app_key === void 0 ? void 0 : app_key.toString()) || '';
    corporationId.value = (corp_id === null || corp_id === void 0 ? void 0 : corp_id.toString()) || '';
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return store.dispatch('company/checkCompanyAdmin', {
                corporation_id: corporationId.value
              });

            case 2:
              // 若只能管理员才能创建空间
              if (spaceConfig.createRole === 'admin') {
                createButtonShow.value = isAdmin.value;
              } // new_biz=1默认初始化时打开新建空间


              openNewBizModal((new_biz === null || new_biz === void 0 ? void 0 : new_biz.toString()) || '');
              getAppStatus();

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(BeaconSpacePage, {
        "app-picture": require('../../assets/space/datatalk.png'),
        "space-header-logo-mobile": "",
        "space-logo": require('../../assets/space/space-logo.png'),
        "app-desc-title": "自由灵活的数据可视化BI工具",
        "app-desc": "DataTalk 支持各类主流数据库、API 以及本地文件接入；无须编码，简单拖拽即可完成图表制作，并支持通过筛选器、时间面板等进行灵活的数据交互；更支持在移动端、邮件、企业微信等多渠道消费。",
        "create-space-title": "",
        adminShowName: true,
        "create-button-show": createButtonShow.value,
        "all-space-show": _unref(spaceConfig).showAll,
        "show-space-id": _unref(spaceConfig).showSpaceId,
        "enable-biz-host": _unref(spaceConfig).enableBizHost,
        "use-app": _unref(spaceConfig).useApp,
        "corporation-id": corporationId.value,
        "app-key": appKey.value,
        "fetch-space-list": fetchSpaceList,
        "role-group-list": roleGroupList,
        "create-space": createSpace,
        onClickSpace: clickSpace
      }, null, 8, ["app-picture", "space-logo", "create-button-show", "all-space-show", "show-space-id", "enable-biz-host", "use-app", "corporation-id", "app-key"])]);
    };
  }
});